export class RecommendationsModel {
    code_no: string 
    code_type: string 
    rec_type: string 
    code_name: string 
    constructor(
        code_no: string, 
        code_type: string, 
        rec_type: string, 
        code_name: string 
    ) { 
        this.code_no = code_no
        this.code_type = code_type
        this.rec_type = rec_type
        this.code_name = code_name
    }

}